import { render } from "./v-login.vue?vue&type=template&id=0cb1fc36"
import script from "./v-login.vue?vue&type=script&lang=js"
export * from "./v-login.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__